import { useEffect } from 'react';
import authService from '../../services/auth';

export const RECHECK_INTERVAL = 30 * 1000;

/**
 * When the user comes back to a tab that stayed open, the shared session is read again (at most every 30 seconds).
 * If it ended or now belongs to another user, the page reloads, so the screens, permissions and data shown are
 * always those of the session the API calls carry.
 * @param {boolean} enabled `true` once this tab holds a session
 */
const useSessionRecheck = (enabled) => {
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        // The page load has just read the session.
        let lastCheck = Date.now();

        const recheck = () => {
            if (document.visibilityState !== 'visible' || Date.now() - lastCheck < RECHECK_INTERVAL) {
                return;
            }

            lastCheck = Date.now();
            authService.isSessionStillForThisUser().then((isSameSession) => {
                if (!isSameSession) {
                    window.location.reload();
                }
            });
        };

        document.addEventListener('visibilitychange', recheck);
        window.addEventListener('focus', recheck);

        return () => {
            document.removeEventListener('visibilitychange', recheck);
            window.removeEventListener('focus', recheck);
        };
    }, [enabled]);
};

export default useSessionRecheck;
